import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { doc, getDoc } from "firebase/firestore";
import { selectActiveProject } from "../projects/selectors";
import { profiles } from "@root/config/firestore";
import { FacebookShareButton, FacebookIcon, TwitterIcon, TwitterShareButton, EmailIcon, EmailShareButton } from "react-share";
import { jsx as ___EmotionJSX } from "@emotion/react";
var ShareDialog = function ShareDialog() {
    var project = useSelector(selectActiveProject);
    var _useState = useState(), _useState2 = _slicedToArray(_useState, 2), profile = _useState2[0], setProfile = _useState2[1];
    var _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), error = _useState4[0], setError = _useState4[1];
    useEffect(function () {
        _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
            var p;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(!error && !profile && project)) {
                                _context.next = 5;
                                break;
                            }
                            _context.next = 3;
                            return getDoc(doc(profiles, project.userUid));
                        case 3:
                            p = _context.sent;
                            if (p.exists()) {
                                setProfile(p.data());
                            }
                            else {
                                setError(true);
                            }
                        case 5:
                        case "end":
                            return _context.stop();
                    }
            }, _callee);
        }))();
    }, [profile, project, error]);
    if (error || !project) {
        return ___EmotionJSX("div", null, "Error: Please contact the site maintainers.");
    }
    if (!project || !profile) {
        return ___EmotionJSX("div", null, "Error: Please contact the site maintainers.");
    }
    var projectInfo = "\"".concat(project.name, "\" by ").concat(profile.displayName);
    return ___EmotionJSX("div", null, ___EmotionJSX("h3", null, "Share"), ___EmotionJSX("div", null, ___EmotionJSX(FacebookShareButton, {
        url: window.location.href,
        quote: projectInfo
    }, ___EmotionJSX(FacebookIcon, null)), ___EmotionJSX(TwitterShareButton, {
        url: window.location.href,
        title: projectInfo,
        hashtags: ["csound"]
    }, ___EmotionJSX(TwitterIcon, null)), ___EmotionJSX(EmailShareButton, {
        url: window.location.href,
        subject: "Csound: " + projectInfo,
        body: projectInfo,
        separator: " ",
        onClick: function onClick(_, link) {
            window.open(link, "_blank");
        }
    }, ___EmotionJSX(EmailIcon, null))));
};
export default ShareDialog;
